import Page from '@/components/Page';
import Lottie from 'lottie-react';
import successLottie from '@/assets/lottie/success.json';
import { useTranslation } from 'react-i18next';
import { IconBrandLine, IconFileCheck, IconCalendarCheck } from '@tabler/icons-react';
import { Button } from '@mantine/core';
import { getMutationResult } from '@/helpers/query';
import { useSelector } from 'react-redux';
import { useGetSummeryfileMutation, useCounselorListMutation } from '@/services/api';
import { useState, useEffect } from 'react';
import Block from '@/components/Block';
import Meeting from '@/components/Meeting';
import { formatDateToString } from '@/helpers/date';
import { formatTime } from '@storybook/blocks';
import classes from './success.module.css';

// t('pages.success.chooseDateForAppointment')

const Success = () => {
  const { t } = useTranslation();
  const { id } = useSelector((state) => state.offer);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [showMeeting, setShowMeeting] = useState(true);
  const [apiGetSummerylink] = useGetSummeryfileMutation();
  const [apiGetCounselorsList] = useCounselorListMutation();
  const [counselors, setCounselors] = useState([]);

  useEffect(() => {
    const fetchCounselors = async () => {
      const { data } = await getMutationResult({}, apiGetCounselorsList);
      // Transform API data to Mantine Select format
      const transformedCounselors = data.counselors?.map((counselor) => ({
        value: counselor.id,
        label: counselor.name,
      })) || [];
      setCounselors(transformedCounselors);
    };
    fetchCounselors();
  }, [apiGetCounselorsList]);

  const downloadFile = async () => {
    setLoading(true);
    try {
      const { data } = await getMutationResult({ id }, apiGetSummerylink);
      const byteArray = new Uint8Array(Object.values(data.data.data));
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'proposal.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch {
      // empty
    } finally {
      setLoading(false);
    }
  };

  const handleMeetingSubmit = (data) => {
    if (data) {
      setShowMeeting(false);
      setResult(data);

      // eslint-disable-next-line no-console
      console.log({ data });
    } else {
      // eslint-disable-next-line no-console
      console.error('got no data from meeting component');
    }
  };

  return (
    <Page
      sideSize="full"
      maxWidth="full"
    >
      <div className={classes.hero}>
        <div className={classes.contents}>
          <h2>{t('pages.success.slogan')}</h2>
          <div className={classes.title} dangerouslySetInnerHTML={{ __html: t('pages.success.title') }} />
          <div className={classes.subtitle} dangerouslySetInnerHTML={{ __html: t('pages.success.subtitle') }} />

          <Button leftSection={<IconFileCheck />} onClick={downloadFile} loading={loading}>
            {t('pages.success.action.title')}
          </Button>
        </div>

        <div className={classes.animation}>
          <Lottie animationData={successLottie} loop={false} />
        </div>
      </div>

      <div className={classes.block}>
        {
          (!result)
            ? (
              <Block title={t('pages.success.block.title')} avatar={<IconBrandLine />}>
                <div className={classes.counselor}>
                  <div
                    className={classes.title}
                    dangerouslySetInnerHTML={{ __html: t('pages.success.block.content') }}
                  />
                </div>
              </Block>)
            : (
              <Block title={t('pages.success.block.meeting.title')} avatar={<IconCalendarCheck />}>
                <div className={classes.counselor}>
                  <p
                    className={classes.meetingContent}
                    dangerouslySetInnerHTML={{
                      __html: t(
                        'pages.success.block.meeting.content',
                        {
                          date: formatDateToString(result.date),
                          start: formatTime(result.startTime),
                          end: formatTime(result.endTime),
                        },
                      ),
                    }}
                  />

                  <p
                    className={classes.meetingContent}
                    dangerouslySetInnerHTML={{ __html: t('pages.success.block.meeting.link', { link: result.eventLink }) }}
                  />
                </div>
              </Block>)
        }
      </div>

      {showMeeting && (
        <div className={classes.form}>
          <Meeting
            counselors={counselors}
            offerId={id}
            onSubmit={handleMeetingSubmit}
          />
        </div>
      )}
    </Page>
  );
};

export default Success;
